import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _lastIndexOfInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/last-index-of";
import _URL from "@babel/runtime-corejs3/core-js-stable/url";
import { Box, Dialog, DialogContent, Drawer, Icon, IconButton, makeStyles, RaiseColors, Typography, useMediaQuery, Button } from "client/componentLibrary";
import * as React from "react";
import { trackEvent, TrackingEventContext, TrackingEventNames } from "utils/Analytics";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function DocumentPreviewWithComments(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    mobileTitle = _ref.mobileTitle,
    desktopTitle = _ref.desktopTitle,
    desktopSubTitle = _ref.desktopSubTitle,
    fileLabel = _ref.fileLabel,
    fileUrl = _ref.fileUrl,
    documentDescriptor = _ref.documentDescriptor,
    Comments = _ref.Comments,
    trackPageView = _ref.trackPageView;
  var classes = makeStyles({
    dialog: {
      "& .MuiDialog-paperWidthSm": {
        maxWidth: 1440
      }
    },
    dialogContent: {
      padding: 0,
      "&:first-child": {
        paddingTop: 0
      }
    }
  })();
  var showTwoColumnLayout = useMediaQuery("(min-width:1152px)");
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    drawerOpen = _React$useState2[0],
    setDrawerOpen = _React$useState2[1];
  return /*#__PURE__*/_jsx(Dialog, {
    open: open,
    onClose: onClose,
    fullScreen: !showTwoColumnLayout,
    classes: {
      root: classes.dialog
    },
    children: /*#__PURE__*/_jsx(DialogContent, {
      classes: {
        root: classes.dialogContent
      },
      children: !showTwoColumnLayout ? /*#__PURE__*/_jsxs(Box, {
        children: [/*#__PURE__*/_jsx(MobileHeader, {
          onClose: onClose,
          title: mobileTitle,
          fileLabel: fileLabel,
          fileUrl: fileUrl
        }), /*#__PURE__*/_jsx(Box, {
          height: "calc(100vh - 90px)",
          children: /*#__PURE__*/_jsx(DocRenderer, {
            url: fileUrl
          })
        }), /*#__PURE__*/_jsxs(Box, {
          children: [/*#__PURE__*/_jsxs(Box, {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            position: "fixed",
            bottom: 0,
            left: 0,
            zIndex: 1,
            bgcolor: RaiseColors.white,
            width: "100vw",
            px: 3,
            py: 1,
            height: 70,
            boxShadow: "0px -2px 10px rgba(36, 43, 56, 0.2)",
            children: [/*#__PURE__*/_jsxs(Box, {
              display: "flex",
              alignItems: "baseline",
              children: [/*#__PURE__*/_jsx(Icon, {
                className: "fal fa-comment",
                fontSize: 20,
                color: RaiseColors.gray300
              }), /*#__PURE__*/_jsx(Box, {
                ml: 1,
                children: /*#__PURE__*/_jsx(Typography, {
                  variant: "paragraph_medium",
                  color: RaiseColors.gray300,
                  children: "Comments"
                })
              })]
            }), /*#__PURE__*/_jsx(Box, {
              children: /*#__PURE__*/_jsx(IconButton, {
                onClick: function onClick() {
                  return setDrawerOpen(!drawerOpen);
                },
                children: /*#__PURE__*/_jsx(Icon, {
                  className: "fa fa-angle-up",
                  fontSize: 16,
                  color: RaiseColors.gray300
                })
              })
            })]
          }), /*#__PURE__*/_jsx(Drawer, {
            anchor: "bottom",
            open: drawerOpen,
            onClose: function onClose() {
              return setDrawerOpen(!drawerOpen);
            },
            children: /*#__PURE__*/_jsxs(Box, {
              children: [/*#__PURE__*/_jsxs(Box, {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                height: 70,
                pl: 3,
                children: [/*#__PURE__*/_jsx(Box, {
                  children: /*#__PURE__*/_jsx(Typography, {
                    variant: "paragraph_medium",
                    color: RaiseColors.black,
                    weight: "semibold",
                    children: "Comments"
                  })
                }), /*#__PURE__*/_jsx(Box, {
                  mr: 3,
                  children: /*#__PURE__*/_jsx(IconButton, {
                    onClick: function onClick() {
                      return setDrawerOpen(!drawerOpen);
                    },
                    children: /*#__PURE__*/_jsx(Icon, {
                      className: "fa fa-angle-down",
                      fontSize: 16,
                      color: RaiseColors.gray300
                    })
                  })
                })]
              }), /*#__PURE__*/_jsx(Box, {
                children: Comments
              })]
            })
          })]
        })]
      }) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(FloatingCloseIcon, {
          onClick: onClose
        }), /*#__PURE__*/_jsxs(Box, {
          display: "flex",
          width: "100vw",
          maxWidth: "100%",
          children: [/*#__PURE__*/_jsx(Box, {
            flexGrow: 1,
            children: /*#__PURE__*/_jsx(Box, {
              height: "calc(100vh - 90px)",
              children: /*#__PURE__*/_jsx(DocRenderer, {
                url: fileUrl
              })
            })
          }), /*#__PURE__*/_jsxs(Box, {
            width: 480,
            minHeight: "100%",
            display: "flex",
            flexDirection: "column",
            children: [/*#__PURE__*/_jsx(Box, {
              children: /*#__PURE__*/_jsx(DialogHeader, {
                title: desktopTitle,
                subTitle: desktopSubTitle,
                fileLabel: fileLabel,
                downloadUrl: fileUrl,
                documentDescriptor: documentDescriptor,
                trackPageView: trackPageView
              })
            }), /*#__PURE__*/_jsx(Box, {
              children: Comments
            })]
          })]
        })]
      })
    })
  });
}
export function BasicDocumentPreview(_ref2) {
  var open = _ref2.open,
    onClose = _ref2.onClose,
    fileLabel = _ref2.fileLabel,
    fileUrl = _ref2.fileUrl,
    mobileTitle = _ref2.mobileTitle,
    desktopTitle = _ref2.desktopTitle,
    desktopSubTitle = _ref2.desktopSubTitle,
    documentDescriptor = _ref2.documentDescriptor,
    trackPageView = _ref2.trackPageView;
  var dialogContentClasses = makeStyles({
    root: {
      padding: 0,
      "&:first-child": {
        paddingTop: 0
      }
    }
  })();
  var showTwoColumnLayout = useMediaQuery("(min-width:1152px)");
  return /*#__PURE__*/_jsx(Dialog, {
    open: open,
    onClose: onClose,
    maxWidth: "xl",
    fullScreen: !showTwoColumnLayout,
    children: /*#__PURE__*/_jsx(DialogContent, {
      classes: dialogContentClasses,
      children: !showTwoColumnLayout ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(MobileHeader, {
          onClose: onClose,
          title: mobileTitle,
          fileLabel: fileLabel,
          fileUrl: fileUrl
        }), /*#__PURE__*/_jsx(Box, {
          height: "calc(100vh - 90px)",
          children: /*#__PURE__*/_jsx(DocRenderer, {
            url: fileUrl
          })
        })]
      }) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(FloatingCloseIcon, {
          onClick: onClose
        }), /*#__PURE__*/_jsxs(Box, {
          display: "flex",
          width: "100vw",
          maxWidth: "100%",
          children: [/*#__PURE__*/_jsx(Box, {
            flexGrow: 1,
            children: /*#__PURE__*/_jsx(Box, {
              height: "calc(100vh - 90px)",
              children: /*#__PURE__*/_jsx(DocRenderer, {
                url: fileUrl
              })
            })
          }), /*#__PURE__*/_jsx(Box, {
            width: 480,
            minHeight: "100%",
            children: /*#__PURE__*/_jsx(DialogHeader, {
              title: desktopTitle,
              subTitle: desktopSubTitle,
              fileLabel: fileLabel,
              downloadUrl: fileUrl,
              documentDescriptor: documentDescriptor,
              trackPageView: trackPageView
            })
          })]
        })]
      })
    })
  });
}
function FloatingCloseIcon(_ref3) {
  var onClick = _ref3.onClick;
  return /*#__PURE__*/_jsx(Box, {
    position: "fixed",
    right: "1.5%",
    top: "2%",
    children: /*#__PURE__*/_jsx(IconButton, {
      onClick: onClick,
      children: /*#__PURE__*/_jsx(Icon, {
        className: "fal fa-times",
        fontSize: 28,
        color: RaiseColors.white
      })
    })
  });
}
function MobileHeader(_ref4) {
  var onClose = _ref4.onClose,
    title = _ref4.title,
    fileLabel = _ref4.fileLabel,
    fileUrl = _ref4.fileUrl;
  return /*#__PURE__*/_jsxs(Box, {
    display: "flex",
    alignItems: "center",
    height: "64px",
    pl: "12px",
    pr: "20px",
    children: [/*#__PURE__*/_jsx(Button, {
      variant: "textButton",
      size: "medium",
      startIcon: /*#__PURE__*/_jsx(Icon, {
        className: "fal fa-angle-left"
      }),
      onClick: onClose,
      children: /*#__PURE__*/_jsx(Typography, {
        color: RaiseColors.black,
        weight: "semibold",
        variant: "paragraph_small",
        noWrap: true,
        children: TruncateTitle(title)
      })
    }), /*#__PURE__*/_jsx(Box, {
      ml: "auto",
      children: /*#__PURE__*/_jsx(IconButton, {
        children: /*#__PURE__*/_jsx(Icon, {
          className: "far fa-download",
          fontSize: 18,
          onClick: function onClick() {
            return downloadFile(fileUrl, fileLabel);
          },
          color: RaiseColors.destructive500
        })
      })
    })]
  });
}

/*
 * Design calls for a split-screen view, so MUI's <DialogTitle /> won't serve us well
 * https://www.figma.com/file/jeuu7WC3j7jkAqoZjktLHl/Client-Side-Redesign?node-id=3096%3A1183
 */
function DialogHeader(_ref5) {
  var title = _ref5.title,
    subTitle = _ref5.subTitle,
    documentDescriptor = _ref5.documentDescriptor,
    fileLabel = _ref5.fileLabel,
    downloadUrl = _ref5.downloadUrl,
    trackPageView = _ref5.trackPageView;
  return /*#__PURE__*/_jsxs(Box, {
    padding: "28px",
    children: [/*#__PURE__*/_jsx(Box, {
      mb: "2px",
      children: /*#__PURE__*/_jsx(Typography, {
        variant: "overline_small",
        color: RaiseColors.gray300,
        children: documentDescriptor
      })
    }), /*#__PURE__*/_jsx(Typography, {
      color: RaiseColors.black,
      weight: "semibold",
      variant: "h3",
      children: TruncateTitle(title)
    }), /*#__PURE__*/_jsx(Box, {
      mb: "20px",
      children: subTitle && /*#__PURE__*/_jsx(Typography, {
        variant: "paragraph_small",
        color: RaiseColors.gray300,
        children: subTitle
      })
    }), /*#__PURE__*/_jsx(Button, {
      variant: "textButton",
      startIcon: /*#__PURE__*/_jsx(Icon, {
        className: "far fa-download",
        color: RaiseColors.destructive500
      }),
      onClick: function onClick() {
        downloadFile(downloadUrl, fileLabel);
        if (trackPageView) {
          trackEvent(TrackingEventNames.ELEMENT_PRESSED, {
            pageView: trackPageView,
            context: TrackingEventContext.DOWNLOAD_DOCUMENT
          });
        }
      },
      children: "Download"
    })]
  });
}
var TruncateTitle = function TruncateTitle(title) {
  if (title.length > 40) {
    return "".concat(title.substring(0, 37), "...");
  } else {
    return title;
  }
};
function DocRenderer(_ref6) {
  var _context;
  var url = _ref6.url;
  if (_includesInstanceProperty(_context = url.substring(_lastIndexOfInstanceProperty(url).call(url, "/") + 1)).call(_context, ".pdf")) {
    return /*#__PURE__*/_jsx("object", {
      type: "application/pdf",
      data: url,
      width: "100%",
      height: "100%"
    });
  }
  return /*#__PURE__*/_jsx("iframe", {
    src: "https://view.officeapps.live.com/op/embed.aspx?src=".concat(encodeURIComponent(url)),
    width: "100%",
    height: "100%",
    frameBorder: "0"
  });
}
var downloadFile = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(signedUrl, fileLabel) {
    var response, blob, url, a, _t;
    return _regeneratorRuntime.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 1;
          return window.fetch(signedUrl, {
            method: "GET",
            credentials: "same-origin",
            headers: {
              "Content-Type": "application/json",
              "Cache-Control": "max-age=0"
            }
          });
        case 1:
          response = _context2.sent;
          _context2.next = 2;
          return response.blob();
        case 2:
          blob = _context2.sent;
          url = _URL.createObjectURL(blob);
          a = document.createElement("a");
          a.href = url;
          a.download = fileLabel !== null && fileLabel !== void 0 ? fileLabel : signedUrl.substring(_lastIndexOfInstanceProperty(signedUrl).call(signedUrl, "/") + 1, _lastIndexOfInstanceProperty(signedUrl).call(signedUrl, "?X"));
          document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
          a.click();
          a.remove();
          _context2.next = 4;
          break;
        case 3:
          _context2.prev = 3;
          _t = _context2["catch"](0);
          console.log(_t);
        case 4:
        case "end":
          return _context2.stop();
      }
    }, _callee, null, [[0, 3]]);
  }));
  return function downloadFile(_x, _x2) {
    return _ref7.apply(this, arguments);
  };
}();